import { ServiceBase, PagedResult } from "./ServiceBase";
import { ShoppingCart } from '../models/ShoppingCart';

export default class CartSearchService extends ServiceBase {
    public static async cartSearch(cartId: string, cartName: string,email: string, impactPartnerId: any, pageIndex: number, pageSize: number) {
        let response = await this.requestJson<PagedResult<ShoppingCart>>({
            url: `/api/cartsearch/search`,
            method: "POST",
            data: {
                cartId, cartName, email, impactPartnerId, pageIndex, pageSize
            }
        });

        return response;
    }
}